import React, { FC, useEffect, useRef, useState } from "react";
import { Row, Col, Button, Card, Tooltip, Select, Collapse, Spin } from "antd";
import "./profile.scss";
import MemberItems from "../items";
import { ArrowRightOutlined, DoubleLeftOutlined } from "@ant-design/icons";
import membersService from "@services/members.service";
import { getProgressColorCode } from "@pages/utils/utils";
import { IMembers } from "@pages/members/constants";
import IconChevron from "@assets/icon_chevron.svg";
// import CustomTooltip from "@pages/tool-tip";

import CheckBox from "../../members/components/checkbox";
import { centricClientCheck, formatDisplayDate, formatPhoneNumber, getClientName, milleniumClientCheck } from "@utils/helpers";
import { head, findIndex, isEmpty, forEach, get } from "lodash";
import { useMemberListStore } from "@stores/useMemberListStore";
import moment from "moment";
import { CanEdit } from "@components/accessLevel";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import { KNOWMORE, dateFormatConfig } from "@utils/constants";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { useEolStore } from "@stores/eolStore";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";

const { Panel } = Collapse;
interface IProfileProps {
  currentMember: IMembers;
  setCollapsedProfile: React.Dispatch<React.SetStateAction<boolean>>;
  tabKeyHandler: (x: any) => void;
  setShowLoader: (x: any) => void;
  updateStatus: any;
  leftBtn: boolean;
  setLeftBtn: (x: any) => void;
  setRightBtn: (x: any) => void;
  getCurrentPage: () => number;
  changeMember: (x: any) => void;
  direction: any;
  count: any;
  setActiveTabKey?: any;
}

const Profile: FC<IProfileProps> = ({
  currentMember,
  setCollapsedProfile,
  tabKeyHandler,
  setShowLoader,
  updateStatus,
  leftBtn,
  setLeftBtn,
  setRightBtn,
  getCurrentPage,
  changeMember,
  direction,
  count,
  setActiveTabKey
}) => {
  const [selectedChronicesType, setSelectedChronicesType] = useState("");
  const [selectedChronicesData, setSelectedChronicesData] = useState([]);
  // const [heigh, setHeight] = useState(0);
  const noOfPrioritized = useRef(0);
  const memberItemRef: any = useRef(null);
  // const chronics: any = data?.chronics ? head(data.chronics) : {};
  const totalCount = useMemberListStore((state) => state.totalPages);
  const rowsPerPage = useMemberListStore((state) => state.rowsPerPage);
  const [otherDetailsActivePanel, setotherDetailsActivePannel] = useState<any[]>([]);
  const [otherDetailsActivePanel2, setotherDetailsActivePannel2] = useState<any[]>([]);
  const [chronicsActivePanel, setchronincssActivePannel] = useState<any[]>([]);
  const [terminalIllnessActivePanel, setterminalIllnessActivePanel] = useState<any[]>([]);

  const setCarePlanProgramActive = useCareCoordinationStore((state) => state.setCarePlanProgramActive);
  const setActiveKeyForPhysicianCarePlan = useCareCoordinationStore((state) => state.setActiveKeyForPhysicianCarePlan);
  const setActivekeyPhysicianCarePlanCondition = useCareCoordinationStore((state) => state.setActivekeyPhysicianCarePlanCondition);
  const memberDetailListRegistryDropDown = useGlobalInformationStore((state) => state.memberDetailListRegistryDropDown);
  const [eolList] = useEolStore((state) => [state.eolList]);
  const [memberData, chronicsList] = useMemberDetailsStore((state) => [state.memberData, state.chronicsList]);
  const chronics: any = chronicsList ? head(chronicsList) : {};
  const patientId = currentMember?.patient_id;
  const isCentric = centricClientCheck()

  useEffect(() => {
    if (direction !== undefined && count !== 0) {
      const right = direction;
      changeMember(right);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  useEffect(() => {
    const members = membersService?.getMemberList;
    let idx = findIndex(members, { patient_id: currentMember?.patient_id });

    if (getCurrentPage() === 1 && idx === 0) {
      setLeftBtn(true);
    } else if (leftBtn !== false) {
      setLeftBtn(false);
    }

    const totalNumberOfPages = Math.ceil(totalCount / rowsPerPage);

    if (totalNumberOfPages === getCurrentPage() && idx === membersService?.getMemberList?.length - 1) {
      setRightBtn(true);
    } else {
      setRightBtn(false);
    }

    // Below code will be removed once data driven code is merged with this branch

    const utterance = new SpeechSynthesisUtterance(currentMember?.patient_name);
    utterance.voice = window.speechSynthesis.getVoices()[2];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  useEffect(() => {
    console.log("Profile.useEffect4");
    if (chronicsList && chronicsList && chronicsList.length > 0) {
      if (selectedChronicesType === "") {
        setSelectedChronicesType(chronicsList[0].type);
        setSelectedChronicesData(chronicsList[0].disease);
      } else {
        const selectedChronics = chronicsList.find((data: any) => data.type === selectedChronicesType);
        const selectedData: any = selectedChronics.disease;
        setSelectedChronicesData(selectedData);
        if (selectedChronicesType === "Priority") {
          noOfPrioritized.current = selectedChronics.noOfPrioritized;
        }
      }
    } else {
      setSelectedChronicesType("");
      setSelectedChronicesData([]);
    }
  }, [chronicsList]);

  const onOtherdetailsCollapseChange = () => {
    if (otherDetailsActivePanel.length > 0) {
      setotherDetailsActivePannel([]);
    } else setotherDetailsActivePannel(["1"]);
  };
  const onOtherdetailsCollapseChange2 = () => {
    if (otherDetailsActivePanel2.length > 0) {
      setotherDetailsActivePannel2([]);
    } else setotherDetailsActivePannel2(["1"]);
  };

  const onchronicsCollapseChange = () => {
    if (chronicsActivePanel.length > 0) {
      setchronincssActivePannel([]);
    } else setchronincssActivePannel(["1"]);
  };

  const MemberProfileCheckBox = (props: any) => {
    let { label, classificationType, dataIndex, key, optionalValue } = props;
    let checkForRegistryDependentProgramStatus:any = [];
    let defaultDisabledRegistry = optionalValue?.disabled ? optionalValue?.disabled : false;

    const [registryDependentProgramsStatus] = usePatientProfileStore((state) => [state.registryDependentProgramsStatus]);

    const toolTipForRegistryDropDown = () => {
      if(optionalValue?.registryLinkedProgram) {
        const registryLinkedOptions = optionalValue?.registryLinkedProgram;
        forEach(registryLinkedOptions, (item:any)=> {
          if(registryDependentProgramsStatus.includes(item?.careProgramConfiguredProgramName)) {
            checkForRegistryDependentProgramStatus.push(item?.programLabel)
          }
        })

        if (checkForRegistryDependentProgramStatus?.length > 0) {
          const programList:any = checkForRegistryDependentProgramStatus?.join(",")
          return (
            <div>{`An active ${programList} program is running, complete the program to remove the patient from ${programList}.`}</div>
          );
        }
      }
      return null;
    };

    return (
      <Tooltip placement="topLeft" title={toolTipForRegistryDropDown()} overlayClassName={"member-detail-profile-registry-tooltip"}>
        <Row className="profileCheckBox" key={key}>
          <Col span={22} className="f16 w400 clr-lightGrayColor">
            {label}
          </Col>
          <Col span={2}>
            <CanEdit hide={false}>
              <CheckBox
                label={label}
                patientId={currentMember?.patient_id}
                classificationType={classificationType}
                dataIndex={dataIndex}
                currentMember={currentMember}
                style={{ display: "flex", justifyContent: "center" }}
                updateStatus={updateStatus}
                disabled={checkForRegistryDependentProgramStatus?.length > 0 || defaultDisabledRegistry}
                setPageLoader={setShowLoader}
              ></CheckBox>
            </CanEdit>
          </Col>
        </Row>
      </Tooltip>
    );
  };

  const terminalIllnessHeader = (count: any = 0) => {
    return (
      <div className="profileTerminalIllness__header">
        <div className="profileTerminalIllness__header__title">Terminal Illness</div>
        <div className="profileTerminalIllness__header__count">{`(${count})`}</div>
      </div>
    );
  };

  const sortTerminalIllnessData = (terminalIllnessData: any) => {
    terminalIllnessData.sort((a: any, b: any) => {
      return moment(formatDisplayDate(a.last_dianosis_date, "createDateFormat", "createDateFormat")).format("YYYY-MM-DD") <
        moment(formatDisplayDate(b.last_dianosis_date, "createDateFormat", "createDateFormat")).format("YYYY-MM-DD")
        ? 1
        : -1;
    });
    return terminalIllnessData;
  };

  const terminalIllnessTooltip = (terminalIllnessData: any) => {
    return (
      <div className="profileTerminalIllness__illnessContainer__tooltip">
        <div className="profileTerminalIllness__illnessContainer__tooltip__first-diagnosis" style={{ fontSize: "1rem", fontWeight: "200" }}>
          First Diagnosed Date :{" "}
          <span className="profileTerminalIllness__illnessContainer__tooltip__first-diagnosis__date" style={{ fontWeight: "500" }}>
            {formatDisplayDate(terminalIllnessData?.first_diagnosis_date, "reminderDateActualFormat", "")}
          </span>
        </div>
        <div className="profileTerminalIllness__illnessContainer__tooltip__last-diagnosis" style={{ fontSize: "1rem", fontWeight: "200" }}>
          Last Diagnosed Date :{" "}
          <span className="profileTerminalIllness__illnessContainer__tooltip__first-diagnosis__date" style={{ fontWeight: "500" }}>
            {formatDisplayDate(terminalIllnessData?.last_dianosis_date, "reminderDateActualFormat", "")}
          </span>
        </div>
      </div>
    );
  };

  const getTerminalIllnessIcon = (terminalIllnessDescription: any) => {
    return terminalIllnessDescription?.includes("cirrhosis of the liver")
      ? "cirrhosis of the liver"
      : terminalIllnessDescription?.includes("hiv")
      ? "hiv"
      : terminalIllnessDescription?.includes("end stage renal disease (esrd)")
      ? "end stage renal disease (esrd)"
      : terminalIllnessDescription?.includes("dementia")
      ? "dementia"
      : terminalIllnessDescription?.split(":")[0]?.trim();
  };

  const onTerminalIllnessCollapseChange = () => {
    if (terminalIllnessActivePanel.length > 0) {
      setterminalIllnessActivePanel([]);
    } else setterminalIllnessActivePanel(["1"]);
  };

  const physicianCarePlanResponse = useCareCoordinationStore((state) => state.initialResponse);
  const memberProfilePhysicianCarePlanLoader = useCareCoordinationStore((state) => state.memberProfilePhysicianCarePlanLoader);


  /********************************** */

  return (
    <div className="profile-card">
      <Card className="profile-details-card">
        <div className="member-priority">
          <div className="member-riskCategory" style={{ color: getProgressColorCode(currentMember?.risk_category_flag), borderColor: getProgressColorCode(currentMember?.risk_category_flag) }}>
            {currentMember?.risk_category}
          </div>
          <div className="member-priority__title f16 w500 clr-n125">Priority: </div>
          <div className="member-priority__value f16 w500 clr-n125">{currentMember?.priority}</div>
        </div>
        {(currentMember?.patient_hopital_discharge_flag === "Y" || currentMember?.patient_hopital_admission_flag === "Y") && (
          <Row className="adt-feed-badge">
            <div className="adt-feed-button-container">
              <Button
                shape="round"
                className={`ant-btn ant-btn-round ant-btn-default adt-feed-button`}
                size="middle"
                onClick={() => {
                  tabKeyHandler("4");
                }}
              >
                {currentMember?.patient_hopital_discharge_flag === "Y" ? "Discharged Recently" : currentMember?.patient_hopital_admission_flag === "Y" ? "Hospitalized" : ""}

                <i
                  style={{
                    marginLeft: 12,
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className={`icon-arrow-circle-right`}
                />
              </Button>
            </div>
          </Row>
        )}
        <div className="personal-details-group">
          <Tooltip
            overlayInnerStyle={{
              padding: "12px",
              borderRadius: "8px",
              backgroundColor: "#091e42",
              height: "40px",
              lineHeight: 1,
            }}
            title="Hide member profile"
          >
            <Button className="profile-collabse-btn" icon={<DoubleLeftOutlined />} size={"middle"} onClick={() => setCollapsedProfile(true)} />
          </Tooltip>
          {!isCentric && (
            <MemberItems
              left={12}
              right={12}
              containerClass={"personalDetailContainer"}
              leftClass="f16 w400 clr-lightGrayColor"
              rightClass="f16 w500 clr-n125"
              name={"Record ID"}
              value={memberData?.recordId}
              keycolor={"keycolor"}
            />
          )}
          <MemberItems
          left={12}
          right={12}
          containerClass={"personalDetailContainer"}
          leftClass="f16 w400 clr-lightGrayColor"
          rightClass="f16 w500 clr-n125"
          name={"Age"}
          value={memberData?.memberAge}
          keycolor={"keycolor"}
        />
          <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Gender"}
            value={memberData?.memberGender}
            keycolor={"keycolor"}
          />
          {/* <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Weight"}
            value={data?.memberPersonalInfo?.memberWeight}
          />
          <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Height"}
            value={data?.memberPersonalInfo?.memberHeight}
          /> */}
          <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Language"}
            value={memberData?.memberPreferableLanguage}
            keycolor={"keycolor"}
          />
          <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Phone Number"}
            value={formatPhoneNumber(memberData?.memberPhoneNumber, "usFormat")}
            keycolor={"keycolor"}
          />
        </div>
        {!isCentric && (
          <>
            <div className="otherDetailsContainer">
              <Collapse activeKey={otherDetailsActivePanel2} expandIconPosition={"right"} bordered={false} onChange={onOtherdetailsCollapseChange2}>
                <Panel header={<span className="f16 w400 clr-lightGrayColor">Physician Care Plan</span>} key="1">
                  <Spin spinning={memberProfilePhysicianCarePlanLoader}>
                    <div className="ui-physician-care-plan">
                      <PhysicianCarePlanNoteView {...{ physicianCarePlanResponse }} />
                      <div
                        className="ui-physician-care-plan__know-more"
                        onClick={() => {
                          setActiveTabKey("3");
                          setCarePlanProgramActive("care-plan-config");
                          //setActivekeyPhysicianCarePlanCondition is used stopping the useffect from changing the activeKeyForPhysicianCarePlan state to default cards
                          setActivekeyPhysicianCarePlanCondition({ from: KNOWMORE });
                          setActiveKeyForPhysicianCarePlan(["2"]);
                        }}
                      >
                        Know More <ArrowRightOutlined />
                      </div>
                    </div>
                  </Spin>
                </Panel>
              </Collapse>
            </div>
            <div className="otherDetailsContainer">
              <Collapse activeKey={otherDetailsActivePanel} expandIconPosition={"right"} bordered={false} onChange={onOtherdetailsCollapseChange}>
                <Panel header={<span className="f16 w400 clr-lightGrayColor">Registry </span>} key="1">
                  {memberDetailListRegistryDropDown?.map((obj: any, index: number) => (
                    <MemberProfileCheckBox
                      label={obj.label}
                      classificationType={obj.classification}
                      dataIndex={obj?.value}
                      key={`MemberProfileCheckBox${index}`}
                      updateStatus={updateStatus}
                      optionalValue={obj?.optionalValue}
                    />
                  ))}
                </Panel>
              </Collapse>
            </div>
          </>
        )}
        <div className={`profileChronicsContainer ${isCentric ? 'withMargin' : ''}`}>
          {selectedChronicesData.length > 0 ? (
            <Collapse className="chronicsHeader" activeKey={chronicsActivePanel} expandIconPosition={"right"} bordered={false} onChange={onchronicsCollapseChange}>
              <Panel
                header={
                  <span className="f16 w400 clr-lightGrayColor">
                    Chronic Condition <span className="f500">({selectedChronicesData.length})</span>
                  </span>
                }
                key="1"
              >
                <Row className="chronucs-filter-container">
                  {/* <Col span={10} className="chronic-filter-title-icon">
            <div>
              <h1 className="f16 w600 clr-lightGrayColor" style={{ margin: 0 }}>
                Chronic Condition ({selectedChronicesData.length})
              </h1>
            </div>
          </Col> */}
                  {/* <Col span={2} className="chronic-filter-title-icon">
            {selectedChronicesData.length > 0 && (
              <CustomTooltip toolTipvalue="Chronic Condition prioritization">
                <i className="icon-info clr-n125" style={{ fontSize: "20px", width: "2px", height: "2px" }} />
              </CustomTooltip>
            )}
          </Col> */}
                  <Col span={12} className="chronic-filter-dropdown">
                    {selectedChronicesData.length > 0 && (
                      <Select
                        style={{ width: 140 }}
                        placeholder="Select chronics type"
                        onChange={(e) => setSelectedChronicesType(e)}
                        value={selectedChronicesType}
                        defaultValue={selectedChronicesType}
                        suffixIcon={
                          <span>
                            <img src={IconChevron} alt="chevron-icon" />
                          </span>
                        }
                      >
                        {chronicsList &&
                          chronicsList &&
                          chronicsList.map((member: any) => {
                            return (
                              <Select.Option key={member.type} value={member.type}>
                                {member.type}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    )}
                  </Col>
                </Row>
                <div className="chronics-container custom-scroll-bar" ref={memberItemRef}>
                  <div className={selectedChronicesData.length > noOfPrioritized.current && selectedChronicesType === chronics?.type ? "chronics__top_ten" : ""}>
                    {selectedChronicesData.slice(0, noOfPrioritized.current).map((chronic: any, index: number) => {
                      return (
                        <div className="profileTerminalIllness__illnessContainer__illness" key={index}>
                          <div className="profileTerminalIllness__illnessContainer__illness__image">
                            <img
                              src={"./Chronic_Diseases/" + (chronic.toLowerCase() === "hip/pelvic fracture" ? "pelvic fracture" : chronic.toLowerCase()) + ".svg"}
                              alt={""}
                              height="25px"
                              width="25px"
                              className="chronic_icon_color"
                            />
                          </div>
                          <div className="profileTerminalIllness__illnessContainer__illness__title">{chronic}</div>
                        </div>
                      );
                    })}
                  </div>
                  <div className={selectedChronicesType === chronicsList?.[0]?.type ? `chronics_non_priority` : ""}>
                    {selectedChronicesData?.slice(noOfPrioritized?.current, selectedChronicesData?.length)?.map((chronic: any, index: number) => {
                      return (
                        <div className="profileTerminalIllness__illnessContainer__illness" key={index}>
                          <div className="profileTerminalIllness__illnessContainer__illness__image">
                            <img
                              src={"./Chronic_Diseases/" + (chronic?.toLowerCase() === "hip/pelvic fracture" ? "pelvic fracture" : chronic?.toLowerCase()) + ".svg"}
                              alt={""}
                              height="25px"
                              width="25px"
                              className="chronic_icon_color"
                            />
                          </div>
                          <div className="profileTerminalIllness__illnessContainer__illness__title">{chronic}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Panel>
            </Collapse>
          ) : (
            <div className="f16 w400 clr-lightGrayColor no-chronics-to-show">
              Chronic Condition <span className="f500">({selectedChronicesData.length})</span>
            </div>
          )}
        </div>
        {!isCentric && (
          <div className="profileTerminalIllness">
            {eolList?.length > 0 ? (
              <Collapse expandIconPosition={"right"} bordered={false} activeKey={terminalIllnessActivePanel} onChange={onTerminalIllnessCollapseChange}>
                <Panel header={terminalIllnessHeader(eolList?.length)} key="1">
                  <div className={`profileTerminalIllness__illnessContainer ${eolList?.length > 5 ? "height" : ""}  custom-scroll-bar`}>
                    {sortTerminalIllnessData(eolList)?.map((illness: any, index: any) => {
                      return (
                        <Tooltip
                          placement="top"
                          title={terminalIllnessTooltip(illness)}
                          overlayClassName="table-tooltip"
                          overlayInnerStyle={{ width: "17.5rem" }}
                          key={`terminalIllnessTooltip${index}`}
                        >
                          <div className="profileTerminalIllness__illnessContainer__illness" key={index}>
                            <div className="profileTerminalIllness__illnessContainer__illness__image">
                              <img
                                src={`./Chronic_Diseases/${getTerminalIllnessIcon(illness?.disease_description.toLowerCase())}.svg`}
                                alt={""}
                                height="25px"
                                width="25px"
                                className="chronic_icon_color"
                              />
                            </div>
                            <div className="profileTerminalIllness__illnessContainer__illness__title">{illness?.disease_description}</div>
                          </div>
                        </Tooltip>
                      );
                    })}
                  </div>
                </Panel>
              </Collapse>
            ) : (
              <div className="profileTerminalIllness__emptyData">{terminalIllnessHeader()}</div>
            )}
          </div>
        )}
        <div className="otherDetailsContainer">
          <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Assigned PCP Name"}
            value={memberData?.pcpName}
            keycolor={"keycolor"}
          />
          <MemberItems
            left={12}
            right={12}
            containerClass={"personalDetailContainer"}
            leftClass="f16 w400 clr-lightGrayColor"
            rightClass="f16 w500 clr-n125"
            name={"Phone Number"}
            value={formatPhoneNumber(memberData?.pcpPhoneNumber, "usFormat")}
            keycolor={"keycolor"}
          />
        </div>
        {/* commented it for temporary basis for Bug Id - 3768 -- AUthor : @TaniaSharma */}
        {/* <div className="pointerContainer">
          <Button
            type="text"
            shape="circle"
            size={"small"}
            className="add-pointer"
            icon={<i className="icon icon-plus-circle" />}
          >
            Add Pointer
          </Button>
        </div> */}
      </Card>
    </div>
  );
};

function PhysicianCarePlanNoteView({ physicianCarePlanResponse }: any) {
  const physicianCarePlanNotes = useCareCoordinationStore((state) => state.physicianCarePlanNotes);

  if (milleniumClientCheck()) {
    const firstNote = get(physicianCarePlanNotes, "[0]");

    const description = get(firstNote, "notes", "")
    const notesCreateDate = get(firstNote, "notesCreateDate", "");
    const careMangerName = `${get(firstNote, "careMgrLastName", "")}, ${get(firstNote, "careMgrFirstName", "")}`;

    return <PhysicianNote dataExistsCondition={firstNote} description={description} date={notesCreateDate} name={careMangerName} />;
  } else {
    return (
      <PhysicianNote
        dataExistsCondition={!isEmpty(physicianCarePlanResponse)}
        description={physicianCarePlanResponse?.careplan_note_description}
        date={physicianCarePlanResponse?.physician_care_plan_date}
        name={physicianCarePlanResponse?.pcp_name}
      />
    );
  }
}

function PhysicianNote({ dataExistsCondition = false, description = "", date = moment(), name = "" }: any) {
  const [showFullDescription, setFullDescription] = useState(false);
  const showFullDescriptionHandler = () => {
    setFullDescription(!showFullDescription);
  };

  const noteDescription = description.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

  return (
    <>
      {dataExistsCondition ? (
        <>
          <div className="ui-physician-care-plan__note">
            {<div className={`noteContent notes-html ${showFullDescription ? "more" : "less"}`} dangerouslySetInnerHTML={{ __html: description }}></div>}
            {noteDescription.length > 100 && (
              <span className="ui-physician-care-plan__know-more" onClick={showFullDescriptionHandler}>
                ... Read {showFullDescription ? "Less" : "More"}
              </span>
            )}
          </div>

          <div className="ui-physician-care-plan__footer">
            {moment(date)?.format(dateFormatConfig.get(getClientName())["defaultDateFormat"])} | {name}
          </div>
        </>
      ) : (
        <div className="ui-physician-care-plan__note">
          <DataNotFound message={NO_DATA_FOUND} />
        </div>
      )}
    </>
  );
}

export default Profile;
